import { render } from "./ManageAccess.vue?vue&type=template&id=24741d9b&scoped=true"
import script from "./ManageAccess.vue?vue&type=script&lang=js"
export * from "./ManageAccess.vue?vue&type=script&lang=js"

import "./ManageAccess.vue?vue&type=style&index=0&id=24741d9b&scoped=true&lang=css"

import exportComponent from "/Volumes/Projects/inqi/inqi-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24741d9b"]])

export default __exports__